module.exports = __webpack_public_path__ + "static/media/kozamgi_rwamiko5.9d62dc89.jpg";